<template>
  <div>
    <template>
      <div class="mb-6">
        <b-headline type="h1" typography="h2" class="mb-8 inline" v-html="headlineCopy" />
        <span class="text-blue text-h3 m:text-h2 italic inline ml-2">
          {{ this.spaceName }}
        </span>
      </div>
      <p class="mb-8 text-base l:text-xl" v-html="mainCopy" />
    </template>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"

export default {
  name: "CopySection",
  components: {
    BHeadline
  },
  props: {
    spaceName: {
      type: String,
      required: true
    },
    spaceB2b: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    headlineCopy() {
      return this.spaceB2b ? this.$t("headlineB2b") : this.$t("headline")
    },
    mainCopy() {
      return this.spaceB2b
        ? this.$t("mainB2b", { spaceName: this.spaceName })
        : this.$t("main", { spaceName: this.spaceName })
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "You’ve been invited to the Space:",
        headlineB2b: "Your colleague invited you to join the Space:",
        main: "Join the {spaceName} Space to listen to their Blinkist recommendations, for free!",
        mainB2b: "Join the {spaceName} Space to listen to their Blinkist recommendations, for free!"
      },
      de: {
        headline: "Du wurdest zu diesem Space eingeladen:",
        headlineB2b: "Du wurdest zu diesem Space eingeladen:",
        main: "Werde Mitglied in diesem Space, um dir die Empfehlungen kostenlos anzuhören!",
        mainB2b: "Werde Mitglied in diesem Space, um dir Empfehlungen deiner Kollegen kostenlos anzuhören!"
      }
    }
  }
}
</script>
